<template>
  <v-container fluid fill-height class="login">
    <v-layout align-center justify-center>
      <v-flex xs12 sm7 md5 lg4 xl3>
        <v-layout align-center justify-center row>
          <h1 class="logo">
            DeriProject
          </h1>
        </v-layout>
        <v-card class="elevation-12">
          <v-app-bar dark color="primary">
            <v-toolbar-title>Login</v-toolbar-title>
          </v-app-bar>
          <v-card-text>
            <v-form>
              <v-text-field prepend-icon="mdi-account-circle" name="login" label="Login" type="text"
                            v-model="username" @keyup.enter="$refs.pass.focus()"></v-text-field>
              <v-text-field prepend-icon="mdi-lock" name="password" ref="pass" label="Password" id="password" type="password"
                            v-model="password" @keyup.enter="login()"></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-on:click="login" class="send-btn" color="#42b983" dark large>
              Login
              <v-icon right>mdi-send</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import {mapActions} from 'vuex'

  export default {
    data() {
      return {
        username: null,
        password: null,
        loading: false
      }
    },

    methods: {
      ...mapActions(['fetchToken', 'setUser', 'fetchUser']),
      login() {
        this.loading = true;
        this.fetchToken({
          username: this.username,
          password: this.password
        }).then(() => {
          this.fetchUser()
        }).finally(() => {
          setTimeout(() => {
            this.loading = false
          }, 500)
        })
      }
    }
  }
</script>

<style>

  .login .v-card > div.v-card__text {
    padding: 35px 35px 0;
  }

  .login .v-card > div.v-card__actions {
    padding: 15px 35px 35px;
  }


  .login {
  }

  .logo {
    color: white;
    font-size: 80px;
    line-height: 80px;
    margin-bottom: 60px;
  }
</style>
